// extracted by mini-css-extract-plugin
module.exports = {"root":"HintByRequestType_root__GFeTF","noHints":"HintByRequestType_noHints__3ptOM"};